import debounce from 'lodash/debounce';
import Mustache from 'mustache/mustache';
import errorHandler from './errorHandler';
import overlays from './overlays';

class IAutocomplete {
    constructor(el, input, template, hiddenField) {
        // @todo Das Fehlerhandling muss noch implementiert werden.
        this.el = el;
        this.input = input;
        this.template = template;
        this.hiddenField = hiddenField;

        this.val = this.input.val();
        this.bindEvents();
        this.action = this.input.data('action');
    }

    // Input-Interactions
    handleInputChanged() {
        const input = this.input.val();
        if (this.val !== input && input !== '') {
            this.clearSavedGeoId();
            this.request(input, true);
        } else {
            this.close();
        }
        this.val = input;
    }

    handleArrowKeys(keyCode) {
        let el;
        if (keyCode === 38) {
            // Arrow-Up
            if (this.el.css('display') === 'block') {
                el = this.el.find('.autocomplete__item.active');
                if (el.html() === this.el.find('.autocomplete__item').first().html()) {
                    this.closeAndSet();
                }
                el.removeClass('active');
                el.prevAll('.autocomplete__item').first().addClass('active');
            }
        } else if (this.el.css('display') === 'none') {
            // Wenn das Fenster noch nicht angezeigt wird. Befülle es und zeige es an.
            this.request(this.input.val(), true);
        } else if (this.el.find('.autocomplete__item.active').length === 0) {
            // Wenn es schon angezeigt wird navigiere dadurch.
            this.el.find('.autocomplete__item').first().addClass('active');
        } else {
            el = this.el.find('.autocomplete__item.active');
            el.removeClass('active');
            el.nextAll('.autocomplete__item').first().addClass('active');
        }
    }

    clearSavedGeoId() {
        this.hiddenField.val('');
    }

    setGeocodeValue(objectClicked) {
        this.input.val(objectClicked.text());
        this.hiddenField.val(objectClicked.data('id'));
        this.close();
        this.input.trigger('autocomplete-geocode-set');
    }

    // Autocomplete Select-Box
    close() {
        this.el.hide();
    }

    closeAndSet() {
        this.setGeocodeValue(this.el.find('.autocomplete__item').first());
        this.el.hide();
    }

    open() {
        this.el.show();
    }

    isOpen() {
        return this.el.css('display') !== 'none';
    }

    update(msg) {
        const customTags = ['%', '%'];
        Mustache.parse(this.template, customTags);
        const rendered = Mustache.render(this.template, msg);
        $('#target').html(rendered);

        this.bindEventsForResults();
    }

    // Ajax-Requests
    request(val, open) {
        $.ajax({
            url: this.action,
            type: 'POST',
            data: {
                string: val,
            },
            success: (msg) => {
                this.handleResponse(msg, open);
            },
        });
    }

    handleResponse(response, open) {
        if ($.isEmptyObject(response)) {
            this.close();
        } else {
            this.update(response);
            if (open === true) {
                this.open();
            } else {
                this.closeAndSet();
            }
        }
    }

    handleKeys(e) {
        if (e.type === 'keydown') {
            if (e.keyCode === 38 || e.keyCode === 40) {
                this.handleArrowKeys(e.keyCode, e);
            } else if (e.keyCode === 9 || e.keyCode === 13) {
                if (this.el.css('display') === 'block') {
                    e.preventDefault();
                }
                if (this.el.find('.autocomplete__item.active').length > 0) {
                    this.setGeocodeValue(this.el.find('.autocomplete__item.active'));
                } else {
                    this.request(this.input.val(), false);
                }
            }
        } else if (
            e.keyCode !== 38
            && e.keyCode !== 40
            && e.keyCode !== 9
            && e.keyCode !== 13
        ) {
            this.handleInputChanged();
        }
    }

    // Bind Events
    bindEvents() {
        this.input.on('keydown.test keyup', e => this.handleKeys(e));

        $(document).on('click', (e) => {
            if ($('.I_OBJ_searchbox__city-wrapper').has(e.target).length === 0 && this.el.css('display') === 'block') {
                if (this.el.find('.autocomplete__item.active').length !== 0) {
                    this.setGeocodeValue(this.el.find('.autocomplete__item.active'));
                } else {
                    this.setGeocodeValue(this.el.find('.autocomplete__item').first());
                }
            }
        });
    }

    bindEventsForResults() {
        this.el.find('.autocomplete__item').on('mousedown', (e) => {
            this.setGeocodeValue($(e.currentTarget));
        });
    }
}

class IListingAutocomplete extends IAutocomplete {
    constructor(el, input, template, hiddenField) {
        super(el, input, template, hiddenField);

        this.requestZipCode = debounce(this.requestZipCode.bind(this), 250);

        this.cityField = $('.I-js-geo-validator-city-target');
    }

    // Overwrite super function
    handleKeys(e) {
        if (e.type === 'keydown') {
            if (e.keyCode === 38 || e.keyCode === 40) {
                this.handleArrowKeys(e.keyCode, e);
            } else if (e.keyCode === 9 || e.keyCode === 13) {
                if (this.el.css('display') === 'block' && e.keyCode === 13) {
                    e.preventDefault();
                }
                if (this.el.find('.autocomplete__item.active').length > 0) {
                    this.setGeocodeValue(this.el.find('.autocomplete__item.active'));
                } else {
                    this.requestZipCode(this.input.val(), false);
                }
            }
        } else if (
            e.keyCode !== 38
            && e.keyCode !== 40
            && e.keyCode !== 9
            && e.keyCode !== 13
        ) {
            this.handleInputChanged();
        }
    }

    // Overwrite super function
    handleInputChanged() {
        const input = this.input.val();

        if (this.val !== input && input !== '') {
            this.clearSavedGeoId();
            this.requestZipCode(input, true);

            if (this.input.hasClass('error') || (this.input.hasClass('correct') && input.length >= 5)) {
                this.validateCity();
            }
        } else {
            this.close();
        }
        this.val = input;
    }

    // Overwrite super function
    open() {
        if (this.input.is(':focus')) {
            super.open();
        }
    }

    // Overwrite super function
    closeAndSet() {
        this.el.hide();
    }

    requestZipCode(val, open) {
        $.ajax({
            url: this.action,
            type: 'POST',
            data: {
                string: val,
            },
            error: (xhr, ajaxOptions, thrownError) => {
                errorHandler.handleError(xhr, thrownError);
                overlays.load.addClass('disabled');
            },
            success: (msg) => {
                this.handleResponse(msg, open);
            },
        });
    }

    validationRequest(val) {
        $.ajax({
            url: this.action,
            type: 'POST',
            data: {
                string: val,
            },
            error: (xhr, ajaxOptions, thrownError) => {
                errorHandler.handleError(xhr, thrownError);
                overlays.load.addClass('diasbled');
            },
            success: (msg) => {
                this.handleValidationResponse(msg);
            },
        });
    }

    handleValidationResponse(msg) {
        if ($.isEmptyObject(msg)) {
            this.setFieldError();
        } else {
            this.hiddenField.val(msg.postcode[0].id);
            this.setFieldCorrect();
        }
    }

    // Overwrite super function
    setGeocodeValue(objectClicked) {
        if ($.isNumeric(objectClicked.text().substring(0, 5))) {
            this.input.val(objectClicked.text().substring(0, 5));
            this.cityField.val(objectClicked.text().substr(6));
            this.hiddenField.val(objectClicked.data('id'));
            this.close();
            this.input.trigger('autocomplete-geocode-set');
            this.cityField.trigger('blur.autofill');
        } else {
            super.setGeocodeValue(objectClicked);
        }
        this.validateCity();
    }

    validateCity() {
        const id = this.hiddenField.val();
        const val = this.input.val();

        if (id === '' && val.length === 5) {
            this.validationRequest(this.input.val());
        } else if (val.length !== 5) {
            this.setFieldError();
        } else {
            this.setFieldCorrect();
        }
        $('body').trigger('submit.enable');
    }

    handleBlur() {
        this.closeAndSet();
        this.validateCity();
    }

    // Overwrite super function
    bindEvents() {
        this.input.on('keydown.test keyup', e => this.handleKeys(e));
        this.input.on('blur', e => this.handleBlur(e));
    }

    setFieldCorrect() {
        this.input.removeClass('error');
        this.input.addClass('correct');
        this.input.parent().find('.I_OBJ_form__error-wrapper').remove();
        $('body').trigger('submit.enable');
    }

    setFieldError() {
        this.input.removeClass('correct');
        this.input.addClass('error');
        if (!(this.input.parent().find('.I_OBJ_form__error-wrapper').length)) {
            /* eslint-disable-next-line */
            this.input.after('<div class="I_OBJ_form__error-wrapper"><div class="I_OBJ_form__error">Bitte geben Sie eine korrekte Postleitzahl an.</div></div>');
        }
        $('body').trigger('submit.enable');
    }
}

const iAutocompleteExport = {
    init() {
        const el = $('.I-js-FM-1-autocomplete-city');
        const inputCity = $('.I-js-FM-1-autocomplete-city-input');
        const template = $('#template').html();
        const hiddenField = $('.I-js-FM-1-autocomplete-geoid');
        const inputZipCode = $('.I-js-geo-validator-zip-input');

        if (el.length) {
            if (inputZipCode.length) {
                // eslint-disable-next-line no-new
                new IListingAutocomplete(el, inputZipCode, template, hiddenField);
            } else {
                // eslint-disable-next-line no-new
                new IAutocomplete(el, inputCity, template, hiddenField);
            }
        }
    },
};

export default iAutocompleteExport;
